export default "__VITE_ASSET__DKgM1HSF__"